"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExceptionOriginTag = void 0;
var ExceptionOriginTag;
exports.ExceptionOriginTag = ExceptionOriginTag;

(function (ExceptionOriginTag) {
  ExceptionOriginTag["JOB"] = "job";
  ExceptionOriginTag["QUEUE"] = "queue";
  ExceptionOriginTag["SCRIPT"] = "script";
  ExceptionOriginTag["WEB"] = "web";
  ExceptionOriginTag["BACKGROUND_PROCESS"] = "backgroundProcess";
})(ExceptionOriginTag || (exports.ExceptionOriginTag = ExceptionOriginTag = {}));